import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    dialog: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      padding: 25,
    },
    text: {
      color: 'orange',
      fontSize: 14,
      '& span': {
        fontWeight: 700,
        textTransform: 'uppercase',
      },
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 10,
    },
    discard_btn: {
      fontSize: '16px !important',
      fontWeight: '700 !important',
      textTransform: 'unset !important',
      minHeight: '30px !important',
      padding: '0px 10px !important',
    },
  })
)

export default useStyles
